import settings from '@/settings'

const todasRedeEmpresas = (headers, filtro = {}) => {
  const params = new URLSearchParams()

  if (filtro.page) params.append('page', filtro.page)
  if (filtro.page_size) params.append('page_size', filtro.page_size)
  Object.keys(filtro).forEach((k) => {
    if (k === 'page' || k === 'page_size') return
    const v = filtro[k]
    if (v === undefined || v === null || v === '') return
    if (typeof v === 'boolean') params.append(k, String(v))
    else params.append(k, String(v))
  })
  const qs = params.toString()
  const url = `${settings.apetrusApi}/rede-empresas/all/${qs ? '?' + qs : ''}`

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const cadastrarRedeEmpresa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/rede-empresas/cadastrar/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const atualizarRedeEmpresa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/rede-empresas/atualizar/${data.id_rede_empresa}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const EmpresasSemRede = (headers, data) => {
  let url = `${settings.apetrusApi}/rede-empresas/semrede/`
  if (data) {
    Object.keys(data).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const EmpresasDaRede = (headers, data) => {
  return fetch(`${settings.apetrusApi}/rede-empresas/empresasdarede/${data.id_rede_empresa}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const inserirEmRedeEmpresa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/rede-empresas/inseriremrede-empresa/${data.id_rede_empresa}/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const deletarRedeEmpresa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/rede-empresas/deletar/${data.id_rede_empresa}/`, {
    method: 'DELETE',
    mode: 'cors',
    headers: headers
  })
}

export default {
  todasRedeEmpresas,
  cadastrarRedeEmpresa,
  atualizarRedeEmpresa,
  EmpresasSemRede,
  EmpresasDaRede,
  inserirEmRedeEmpresa,
  deletarRedeEmpresa
}
